module.exports = __webpack_public_path__ + "static/media/img1-1.d6ca8307.png";